import Input from './input';

export * from './InputPassword/inputPassword';
export * from './input';

export default Input;
